import type { ReactNode } from 'react';

export const symbol_keep: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M634-780v332l77 68q5 5 7 10.6 2 5.59 2 11.56v17.16q0 12.68-8.62 21.18-8.63 8.5-21.38 8.5H510v236q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q450-62.25 450-75v-236H270q-12.75 0-21.37-8.58-8.63-8.59-8.63-21.28v-17.17q0-5.97 2-11.47 2-5.5 7-10.5l71-68v-332h-20q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h354q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-20ZM321-371h312l-59-55v-354H380v354l-59 55Zm156 0Z"
		/>
	</svg>
);
